<template>
    <div v-if="dataList.length" class="add-other-info-wrap">
        <el-form
            :model="formData" 
            label-position="right"
            label-width="120px"
            :rules="formRules"
        >
            <addOtherInfoItem
                v-for="(item) in itemList"
                :key="item.property_id"
                :itemObj="item"
                v-model="formData[item.property_id]"
                @input="onInputFn"
            >
            </addOtherInfoItem>
        </el-form>
    </div>
</template>

<script>
    import addOtherInfoItem from './addOtherInfoItem.vue'
    
    import { defaultOtherInfo } from './data.js'

    export default {
        components: {
            addOtherInfoItem
        },
        props: {
            value: {
                type: Object,
                default: ()=>{
                    return {}
                }
            },
            dataList: { // 选择分类后需要填的其他属性列表
                type: Array,
                default: ()=>{
                    return []
                }
            },
            nowType: { // 当前类型 create创建(第一次) edit编辑(非第一次，有数据回显)
                type: String,
                default: 'create'
            }
        },
        watch: {
            value: {
                immediate: true,
                deep: true,
                handler(nval){
                    if(this.nowType=='edit'){
                        this.formData = nval
                    }
                    // console.log('addOtherInfo-handler-nval:', nval)
                }
            },
            dataList: {
                immediate: true,
                deep: true,
                handler(nval){
                    // console.log('addOtherInfo-handler-nval:', nval)
                    this.initData(nval)
                }
            }
        },
        data(){
            return {
                formData: {},
                itemList: [],
                formRules: {},
                intersectFrom: {} // 编辑时回显可编辑的值
            }
        },
        methods: {
            // 初始化数据 oldArr初始其他属性信息列表
            initData(oldArr){
                let newFormData = {}
                let newItemList = []
                let newFormRules = {}
                // let intersectFrom = {} // 编辑时回显可编辑的值
                oldArr.forEach((item, index)=>{
                    let obj = {}
                    if(item.property_id in defaultOtherInfo){ // 有默认值
                        // if(this.nowType=='create'){ // 第一次创建
                            newFormData[item.property_id] = [{
                                value: defaultOtherInfo[item.property_id].value,
                                name: defaultOtherInfo[item.property_id].name,
                                diy_type: defaultOtherInfo[item.property_id].diy_type
                            }]
                        // }
                        obj = {
                            property_id: item.property_id,
                            label: item.property_name,
                            itemType: defaultOtherInfo[item.property_id].diy_type == 1 ? 'text' : item.type, // diy_type 1=支持自定义，0=不支持自定义
                            options: item.options || [],
                            multipleLimit: item.multi_select_max || 0,
                            diy_type: defaultOtherInfo[item.property_id].diy_type,
                            isDisabled: defaultOtherInfo[item.property_id].isDisabled
                        }
                    }else{ // 无默认值
                        if(item.property_id in this.formData){
                            this.intersectFrom[item.property_id] = this.formData[item.property_id]
                        }
                        if(this.nowType=='create'){ // 第一次创建
                            newFormData[item.property_id] = []
                        }
                        obj = {
                            property_id: item.property_id,
                            label: item.property_name,
                            itemType: item.type, // diy_type 1=支持自定义，0=不支持自定义
                            options: item.options || [],
                            multipleLimit: item.multi_select_max || 0,
                            diy_type: item.diy_type
                        }
                    }
                    if(obj.itemType=='text'){
                        newFormRules[item.property_id] = [
                            {required: true, trigger: 'blur', message: `请输入${item.property_name}`}
                        ]
                    }else{
                        newFormRules[item.property_id] = [
                            {required: true, trigger: 'blur', message: `请选择${item.property_name}`}
                        ]
                    }
                    newItemList.push(obj)
                })
                if(this.nowType=='create'){ // 第一次创建
                    this.formData = JSON.parse(JSON.stringify(newFormData))
                    this.onInputFn()
                }else{
                    this.formData = {
                        ...JSON.parse(JSON.stringify(newFormData)),
                        ...this.intersectFrom,
                    }
                    this.onInputFn()
                }
                console.log(newItemList,'newItemList');
                
                this.itemList = JSON.parse(JSON.stringify(newItemList))
                this.formRules = JSON.parse(JSON.stringify(newFormRules))
            },
            onInputFn(e){
                // console.log('addOtherInfo-onInputFn-e:',e)
                this.$emit('input', this.formData)
                // console.log('addOtherInfo-formData:',this.formData)
            },
            // 表单校验 返回true通过校验
            validateFormFn(){
                let formData = this.formData
                for(let k in formData){
                    if(!this.formData[k].length){ // 没填写
                        this.$message.error(this.formRules[k][0].message)
                        return false
                    }
                }
                if('1618' in formData){ // ISBN编号
                    let reg = /^\d{10}$|^\d{13}$/
                    if(!reg.test(formData['1618'][0].name)){
                        this.$message.error('该ISBN编号无效，应仅为10位或13位阿拉伯数字')
                        return false
                    }
                }
                return true
            }
        }
    }
</script>

<style scoped lang="less">

</style>